import React from 'react'

function BlogSearch({ value, onChange, placeholder }) {
  return (
    <div className="blog-search">
      <div className="search-input-wrapper">
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="search-input"
        />
        <span className="search-icon">🔍</span>
      </div>
    </div>
  )
}

export default BlogSearch
